import classNames from "classnames";
import React, { useEffect, useState } from "react";
import {
  ACTION_COLOR,
  ACTION_COLOR_LIVESITE,
  BG_COLOR,
  BG_COLOR_LIVESITE,
  SLIDER_THUMB_VISIBILITY,
  SLIDER_TRACK_SIZE
} from "../consts";
import styles from "../statics/styles/slider-scss";
const Slider = ({
  min = 0,
  max = 10,
  tabIndex = 0,
  onChange,
  dataHook,
  ariaProps,
  value,
  onChangeCommitted,
  languageDir,
  thumbVisibility = SLIDER_THUMB_VISIBILITY.fixed,
  trackSize = SLIDER_TRACK_SIZE.medium,
  step,
  liveSiteWiring = false,
  ariaLabel,
  disabled,
  isBlackOnWhite
}) => {
  const [fillPercentage, setFillPercentage] = useState(0);
  const track = {
    fill: isBlackOnWhite ? "black" : liveSiteWiring ? ACTION_COLOR_LIVESITE : ACTION_COLOR,
    unFilled: isBlackOnWhite ? "rgba(0,0,0,.2)" : liveSiteWiring ? BG_COLOR_LIVESITE : BG_COLOR,
    gradientDeg: languageDir === "rtl" ? "270deg" : "90deg"
  };
  const bgStyle = {
    background: `linear-gradient(${track.gradientDeg} ,${track.fill} ${fillPercentage}%, ${track.unFilled} ${fillPercentage + 0.1}%)`
  };
  const isFixedThumb = thumbVisibility === SLIDER_THUMB_VISIBILITY.fixed;
  const onKeyUp = (event) => {
    switch (event.key) {
      case "ArrowUp":
      case "ArrowDown":
      case "ArrowRight":
      case "ArrowLeft":
      case "Home":
      case "End":
      case "PageUp":
      case "PageDown":
        onChangeCommitted?.(event.target.valueAsNumber);
        break;
      default:
        return;
    }
  };
  const onKeyDown = (e) => {
    switch (e.key) {
      case "ArrowUp":
      case "ArrowDown":
      case "ArrowRight":
      case "ArrowLeft":
      case "Home":
      case "End":
      case "PageUp":
      case "PageDown":
        onChange?.(e.target.valueAsNumber);
        break;
      default:
        return;
    }
  };
  useEffect(() => {
    setFillPercentage(100 * (value - min) / (max - min));
  }, [value]);
  return /* @__PURE__ */ React.createElement(
    "input",
    {
      ...ariaProps,
      "aria-label": ariaLabel,
      tabIndex,
      type: "range",
      className: classNames(styles.slider, styles.wrapperSlider, styles[trackSize], {
        [styles.slider_fixed_thumb]: isFixedThumb,
        [styles.slider_livesite]: liveSiteWiring,
        [styles.blackOnWhite]: isBlackOnWhite
      }),
      "data-hook": dataHook,
      onChange: (e) => onChange(e.target.valueAsNumber),
      value,
      min,
      max,
      step,
      onMouseUp: (e) => onChangeCommitted?.(e.target.valueAsNumber),
      onTouchEnd: (e) => onChangeCommitted?.(e.target.valueAsNumber),
      onKeyUp,
      onKeyDown,
      style: bgStyle,
      disabled
    }
  );
};
var Slider_default = Slider;
export {
  Slider_default as default
};
//# sourceMappingURL=Slider.js.map
